import React, { useState, useEffect, useRef } from "react";
import "./style2.css";
import logo from "../../Assets/logo.png";
import UnderlinedTextField from "../../Components/UI-Controls/UnderlinedTextField/underlinedTextField";
import user from "../../Assets/user.png";
import lock from "../../Assets/lock.png";
import lock1 from "../../Assets/lock1.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import zelle from "../../Assets/zellle.png"
import zelleW from "../../Assets/zellle.png"
import zelleP from "../../Assets/zelle3.png"

import axios from "axios";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import { security_key, Url } from "../../Services/Api";
import { ToastContainer, toast } from 'react-toastify';
import SpinnerL2 from "../../Components/UI-Controls/spinner2/spinnerL2";
import check from "../../Assets/check.png";
import warn from "../../Assets/warning.png";
import restrict from "../../Assets/restricted.png";
import { useAuth } from "../../Context/Auth/AuthContext";
import OTPInput from "./otpInput";


export default function Login2() {
    const { storeAuthData } = useAuth();
    const [selectedStyle, setSelectedStyle] = useState(null);
    const styling = [
        {
            id: 1,
            background: '/bg6.jpg',
            zelleLogo: zelleW,
            txtColor: "#fff",
            bgColor: "linear-gradient(36deg, rgba(68, 120, 197, 0.8) 0%, rgba(68, 120, 197, 0.8) 100%)"
        },
        {
            id: 2,
            background: '/bg5.jpg',
            zelleLogo: zelleP,
            txtColor: "#595959",
            bgColor: "linear-gradient(36deg, rgba(89, 89, 89, 0.8) 0%, rgba(89, 89, 89, 0.8) 100%)"
        }
    ]


    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * styling.length);
        setSelectedStyle(styling[randomIndex]);
    }, []);




    const [greeting, setGreeting] = useState("");
    const [loading, setLoading] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const options = {
            timeZone: "America/New_York", // Philadelphia timezone
            hour: "numeric",
        };

        const formatter = new Intl.DateTimeFormat("en-US", options);
        const hour = parseInt(formatter.format(new Date()), 10);

        let message = "";
        if (hour < 12) {
            message = "Good Morning";
        } else if (hour < 18) {
            message = "Good Afternoon";
        } else {
            message = "Good Evening";
        }

        setGreeting(`${message}`);
    }, []);





    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });

    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});


    const [stateLogin, setStateLogin] = useState("login");
    const [otpGen, setOtpGen] = useState(false);
    const [accessRestricted, setAccessRestricted] = useState(false);
    const [invalidPass, setInvalidPass] = useState(false);
    const [invalidUname, setInvalidUname] = useState(false);
    const [otp, setOtp] = useState('');
    const [userForOtp, setUserForOtp] = useState(null);
    const [maskedEmail, setMaskedEmail] = useState("");

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: "" }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const newErrors = {};
    //     if (!formData.username) newErrors.username = "Username is required.";
    //     if (!formData.password) newErrors.password = "Password is required.";
    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);
    //         return;
    //     }

    //     setLoading(true);

    //     try {
    //         const response = await axios.post(`${Url}/api/v1/users/login`, formData);




    // const token = response.data.token;
    // const userName = response.data.data.username;
    // const userId = response.data.data._id;

    // console.log('Login successful:', token);

    // sessionStorage.setItem('authToken', token);
    // sessionStorage.setItem('username', userName);
    // sessionStorage.setItem('_id', userId);
    // storeAuthData({
    //     token: token,
    //     user: response.data
    // });
    // setStateLogin("success");


    // // await verifyToken(token);
    // setTimeout(async () => {


    //     await verifyToken(token);
    // }, 2000);
    //     } catch (error) {
    //         console.error('Login failed:', error.response ? error.response.data : error.message);
    //         toast.error(`Login failed: ${error.message}`);
    //     } finally {
    //         setLoading(false);
    //     }
    // };




    // const verifyToken = async (token) => {
    //     try {
    //         console.log("Verifying token:", token);

    //         const headers = {
    //             Authorization: `Bearer ${token}`,
    //             'x-api-key': security_key
    //         };

    //         console.log("Verification headers:", headers);

    //         const response = await axios.get(`${Url}/api/v1/users/verify-token`, { headers });

    //         console.log("Verification response:", response.data);

    //         if (response.data.message === 'Token is valid.') {
    //             setIsLoggedIn(true);
    //             setTimeout(() => {
    //                 window.location.href = "/Dashboard"; // ✅ update this URL
    //             }, 1000);
    //         } else {
    //             console.log('Token verification failed');
    //             sessionStorage.removeItem('authToken');
    //         }
    //     } catch (error) {
    //         if (error.response) {
    //             console.error('Token verification error:', error.response.data);
    //             if (error.response.status === 401) {
    //                 console.log('Unauthorized: Invalid or missing token.');
    //                 sessionStorage.removeItem('authToken');
    //             }
    //         } else {
    //             console.error('Token verification error:', error.message);
    //             sessionStorage.removeItem('authToken');
    //         }
    //     }
    // };


    // NEW LOGIC


    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!formData.username) newErrors.username = "Username is required.";
        if (!formData.password) newErrors.password = "Password is required.";
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${Url}/api/v1/users/login`, formData);

            console.log(response, "here is resp")

            // Check if OTP was sent instead of token
            if (response.data.message === 'OTP sent to your email. Please verify to continue.') {
                setOtpGen(true);
                setUserForOtp(formData.username); // save username for OTP verification
                toast.success('OTP sent to your email.');
                setMaskedEmail(response.data.email)
            }
            else if (response?.data?.message === 'Logged in successfully without OTP.') {
                // setOtpGen(true);
                // setUserForOtp(formData.username); // save username for OTP verification
                // toast.success('OTP sent to your email.');
                // setMaskedEmail(response.data.email)



                const token = response.data.token;
                const userName = response.data.data.username;
                const userId = response.data.data._id;

                console.log('Login successful:', token);

                sessionStorage.setItem('authToken', token);
                sessionStorage.setItem('username', userName);
                sessionStorage.setItem('_id', userId);
                storeAuthData({
                    token: token,
                    user: response.data
                });
                setStateLogin("success");
                setTimeout(async () => {
                    await verifyToken(token);
                }, 2000);
            }


        } catch (error) {
            console.log(error)
            console.error('Login failed:', error.response ? error.response.data : error.message);
            toast.error(`Login failed: ${error.response?.data?.message || error.message}`);

            if (error.response?.data?.message === 'Invalid Username') {
                setStateLogin("invalidus");
                // setUserForOtp(formData.username); // save username for OTP verification
                // toast.success('OTP sent to your email.');
                // setMaskedEmail(response.data.email)
            }
            else if (error.response?.data?.message === "Your access is deactivated. Please contact support for help.") {
                setStateLogin("restricted");
                // setUserForOtp(formData.username); // save username for OTP verification
                // toast.success('OTP sent to your email.');
                // setMaskedEmail(response.data.email)
            }

            else if (error.response?.data?.message === 'Invalid Password') {
                setStateLogin("invalidpass");
                // setUserForOtp(formData.username); // save username for OTP verification
                // toast.success('OTP sent to your email.');
                // setMaskedEmail(response.data.email)
            }

            else {
                setStateLogin("servererror");
                toast.error('Unexpected response.');
            }
        } finally {
            setLoading(false);
        }
    };

    const [otpVerifying, setOtpVerifying] = useState(false);


    const handleVerifyOtp = async (enteredOtp) => {
        if (!enteredOtp || !userForOtp) return toast.error("Please enter OTP");

        setTimeout(async () => {
            setOtpVerifying(true); // ✅ Now starts after 1 second delay

            try {
                const response = await axios.post(`${Url}/api/v1/users/verify-otp`, {
                    username: userForOtp,
                    otp: enteredOtp
                });

                const token = response.data.token;
                const userName = response.data.data.username;
                const userId = response.data.data._id;

                sessionStorage.setItem('authToken', token);
                sessionStorage.setItem('username', userName);
                sessionStorage.setItem('_id', userId);

                storeAuthData({
                    token: token,
                    user: response.data
                });

                setStateLogin("success");
                toast.success("Login successful!");

                setTimeout(async () => {
                    await verifyToken(token);
                }, 2000);

            } catch (error) {
                toast.error(`OTP verification failed: ${error.response?.data?.message || error.message}`);
                sessionStorage.removeItem('username');
                setStateLogin("login");
            } finally {
                setOtpVerifying(false);
            }
        }, 1000); // ⏳ Wait 1 second before starting
    };





    const tabToRouteMap = {
        DASHBOARD: "/Dashboard",
        HEADER: "/Header",
        PAGES: "/Pages",
        E_COMMERCE: "/E-Commerce",
        DESIGN_ROOM: "/design-your-room",
        INVENTORY: "/Inventory",
        APPOINTMENTS: "/Appointments",
        SEO: "/SEO",
        ANALYTICS: "/Analytics",
        FORMS: "/Forms",
        BLOGS: "/Blogs",
        MARKETING: "/Marketing",
        INTEGRATION: "/Integration",
        PERFORMANCE: "/Performance",
        SECURITY: "/Security",
        PRICE_TAGS: "/Price-Tags",
        FLYERS: "/Flyers",
        ADD_ONS: "/Add-Ons",
        SETTINGS: "/Settings"
    };

    const verifyToken = async (token) => {
        try {
            console.log("Verifying token via /api/auth/permissions:", token);

            const headers = {
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            // Single request: verify token + fetch permissions
            const response = await axios.get(`${Url}/api/auth/permissions`, { headers });

            if (response.status !== 200 || !response.data.permissions) {
                console.warn("Token is invalid or permissions not found.");
                sessionStorage.removeItem('authToken');
                return;
            }

            const permissions = response.data.permissions;
            const firstAllowedTab = permissions.find(p => tabToRouteMap[p.tab]);

            if (firstAllowedTab) {
                const allowedPath = tabToRouteMap[firstAllowedTab.tab];
                console.log(allowedPath, "here sis allowd pasth")
                setIsLoggedIn(true);

                if (allowedPath === '/E-Commerce') {
                    setTimeout(() => {
                        window.location.href = `${allowedPath}/All-Orders`;
                    }, 1000);
                } else {
                    setTimeout(() => {
                        window.location.href = allowedPath;
                    }, 1000);
                }

                // Redirect to first allowed route

            } else {
                console.warn("No accessible path found for this user's permissions.");
            }

        } catch (error) {
            console.error("Permission/token verification error:", error?.response?.data || error.message);
            // sessionStorage.removeItem('authToken');
        }
    };







    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (token) {
            verifyToken(token);
        }
    }, []);


    return (
        <div className="login_2_page" style={{
            backgroundImage: `url(${selectedStyle?.background})`
        }}>
            <div className="overlay_l2p" style={{
                background: selectedStyle?.bgColor
            }}>
                {/* here is the main login page */}
                {stateLogin === "login" &&
                    <>

                        <div className={`header_ol2p ${stateLogin === "fading" ? "fade-out" : ""}`}>
                            <a href="https://jasonsfurnitureoutlet.com" target="_blank">
                                <img src={logo} alt="Logo" />
                            </a>
                            <h2>
                                Dashboard <span style={{ fontWeight: "bold" }}>Login</span>
                            </h2>
                        </div>

                        {otpGen === false && <form
                            className={`form_l2p ${stateLogin === "fading" ? "fade-out" : ""}`}
                            onSubmit={handleSubmit}
                        >
                            <p>{greeting}, <span className="greet_p"><br />Let’s get to work...</span></p>
                            <UnderlinedTextField
                                placeholder="Username"
                                svgSrc={user}
                                value={formData.username}
                                onChange={(val) => handleChange("username", val)}
                            />
                            {errors.username && <p className="error-msg">{errors.username}</p>}

                            <UnderlinedTextField
                                placeholder="Password"
                                svgSrc={lock}
                                value={formData.password}
                                onChange={(val) => handleChange("password", val)}
                                type={showPassword ? "text" : "password"}
                                trailingIcon={
                                    showPassword ? (
                                        <FaEye onClick={() => setShowPassword(false)} />
                                    ) : (
                                        <FaEyeSlash onClick={() => setShowPassword(true)} />
                                    )
                                }
                            />


                            {errors.password && <p className="error-msg">{errors.password}</p>}


                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", marginTop: "20px" }}>
                                <div></div>
                                {!loading ? <button type="submit" className="login_2_page_btn"><span>Login</span></button> :
                                    <SpinnerL2 size={35} />}
                            </div>
                        </form>}

                        {otpGen && <div className="otp_screen">
                            <div className="pulse_success_loader">
                                <img src={lock1} alt="check" />
                            </div>
                            {!otpVerifying && <OTPInput
                                maskedEmail={maskedEmail}
                                onComplete={(enteredOtp) => {
                                    setOtp(enteredOtp);
                                    handleVerifyOtp(enteredOtp);
                                }}
                            />}

                            {otpVerifying && <div className="authenticating">
                                <h3>Authenticating <div className="loader_2"></div> </h3>
                            </div>}

                        </div>
                        }
                        {!otpGen && <div className={`content_tfolp ${stateLogin === "fading" ? "fade-out" : ""}`}>
                            <h4>
                                The Jasons Furniture Outlet Dashboard provides a <br />powerful dashboard that offers a comprehensive <br />control of your E-Commerce Website

                            </h4>
                        </div>}

                        {!otpGen && <div className={`footer_ol2p ${stateLogin === "fading" ? "fade-out" : ""}`}>
                            <div></div>
                            <h4><br /> 2020 - 2026 Jasons Furniture Outlet. All Rights Reserved</h4>
                        </div>}

                        {stateLogin === "success" && (
                            <div className="login_successfully fade-in-smoke">
                                <div className="pulse_success_loader">
                                    <img src={check} alt="check" />
                                </div>
                                <h3>Success!</h3>
                                <h5>Your Account Has Been Successfully Logged in.</h5>
                            </div>
                        )}









                    </>
                }

                {stateLogin === "restricted" && (
                    <div className="login_successfully fade-in-smoke">
                        <div className="pulse_success_loader">
                            <img src={warn} alt="check" />
                        </div>
                        <h3>Access Restricted!</h3>
                        <h5>Your access is deactivated. Please contact support for help.</h5>
                        <button onClick={() => {
                            setStateLogin("login")
                        }} style={{ marginTop: "15px" }} className="login_2_page_btn"><span>Try Again</span></button>
                    </div>
                )}


                {stateLogin === "invalidus" && (
                    <div className="login_successfully fade-in-smoke">
                        <div className="pulse_success_loader">
                            <img src={warn} alt="check" />
                        </div>
                        <h3>Authentication Failed!</h3>
                        <h5>Username is Incorrect, Please retry with correct username.</h5>
                        <button onClick={() => {
                            setStateLogin("login")
                        }} style={{ marginTop: "15px" }} className="login_2_page_btn"><span>Try Again</span></button>
                    </div>
                )}

                {stateLogin === "invalidpass" && (
                    <div className="login_successfully fade-in-smoke">
                        <div className="pulse_success_loader">
                            <img src={warn} alt="check" />
                        </div>
                        <h3>Authentication Failed!</h3>
                        <h5>Password is Incorrect, Please retry with correct password.</h5>
                        <button style={{ marginTop: "15px" }} onClick={() => {
                            setStateLogin("login")
                        }} className="login_2_page_btn"><span>Try Again</span></button>
                    </div>
                )}

                {stateLogin === "servererror" && (
                    <div className="login_successfully fade-in-smoke">
                        <div className="pulse_success_loader">
                            <img src={warn} alt="check" />
                        </div>
                        <h3>Authentication Failed!</h3>
                        <h5>Server could not authenticate your login attempt, Please try again.</h5>
                        <button onClick={() => {
                            setStateLogin("login")
                        }} style={{ marginTop: "15px" }} className="login_2_page_btn"><span>Try Again</span></button>
                    </div>
                )}


                {/* here is login successfully */}


                {stateLogin === "success" && <div className="login_successfully">
                    <div className="pulse_success_loader">
                        <img src={check} />
                    </div>
                    <h3>Authentication Successful</h3>
                    <h5>Attempt to login to Jasons Furniture Outlet Dashboard is Authorised.</h5>
                </div>}


            </div>
            <div className="designed_Managed_1">
                <h3 style={{ color: selectedStyle?.txtColor }}>Designed & Managed By</h3>
                <a style={{ display: "flex" }} href="https://zellesolutions.com" target="_blank" ><img src={selectedStyle?.zelleLogo} alt="" srcset="" /></a>
            </div>
        </div>
    );
}
